function add(v1, v2) {
    return { x: v1.x + v2.x, y: v1.y + v2.y }
}

function cross(v1, v2) {
    return v1.x * v2.y -  v1.y * v2.x
}

function multiply(v1, x) {
    return { x: v1.x * x, y: v1.y * x }
}

function rotate(v, angle) {
    return {
        x: v.x * Math.cos(angle) - v.y * Math.sin(angle),
        y: v.x * Math.sin(angle) + v.y * Math.cos(angle)
    }
}

function mag(v) {
    return Math.sqrt(Math.pow(v.x, 2) + Math.pow(v.y, 2))
}

export { add, cross, mag, multiply, rotate }


//////////////////
// WEBPACK FOOTER
// ./src/vectors.js
// module id = 1
// module chunks = 0